import React from "react";
import LazyLoad from "react-lazyload";
import blankJacket from "./../../assets/images/icons/blank_jacket.gif";
import * as Styled from "./Style";

const BagItem = (props) => {
  return (
    <div>
      {props.readyQty || props.duedQty ? (
        <div className="partial">
          <p className="ready">
            {props.readyQty} items will be despatched and charged immediately
          </p>
          <p className="dued">
            {props.duedQty} items will be despatched and charged when available
          </p>
        </div>
      ) : (
        ""
      )}
      <Styled.BagItemStyle>
        <LazyLoad>
          {/* <img
            className="item-img"
            src={`${props.bookImage}`}
            alt=""
          /> */}
          <img
            className="item-img"
            src={`${props.bookImage}`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = blankJacket;
            }}
            alt=""
          />
        </LazyLoad>
        <div className="details">
          <a href={"/" + props.bookISBN} target="_blank">
            {" "}
            <p className="details-title">{props.bookTitle}</p>
          </a>
          <p className="details-author">{props.bookAuthor}</p>
          <p className="details-isbn">
            ISBN: {props.bookISBN} <span>|</span> <br />
            {props.bookType}
          </p>
          <div className="price-each">
            {/* {props.bookDiscountedPrice == props.bookPrice ? (
            props.currency + props.bookPrice
          ) : (
            <span>
              <Styled.OrigPrice>
                {props.currency} {props.bookPrice}
              </Styled.OrigPrice>
              <Styled.DiscountPrice>
                {props.currency}
                {props.bookDiscountedPrice}
              </Styled.DiscountPrice>
            </span>
          )} */}
            {/* discountCode={props.discountCode}
              discountLess={0.2} */}
            {/* {
              props.discountCode == "ALERTSDISCOUNT" ? (
                // If - discountcode is ALERTSDISCOUNT, add 20% off
                <span>
                  <Styled.OrigPrice>
                    {props.currency} {props.bookPrice}
                  </Styled.OrigPrice>
                  <Styled.DiscountPrice>
                    {props.currency}
                    {props.bookPriceAlerts}
                  </Styled.DiscountPrice>
                  <span className="discount-code">{props.discountCode}</span>
                </span>
              )
              :
             // Else - display regular slashed price */}
            {props.bookDiscountedPrice == 0 ? (
              props.currency +
              //  props.bookPrice.toFixed(2)
              (
                Math.round(
                  parseFloat(props.bookPrice.toString().replace(/,/g, "")) * 100
                ) / 100
              ).toFixed(2)
            ) : (
              <span>
                <Styled.OrigPrice>
                  {props.currency}
                  {(
                    Math.round(
                      parseFloat(props.bookPrice.toString().replace(/,/g, "")) *
                        100
                    ) / 100
                  ).toFixed(2)}
                </Styled.OrigPrice>
                <Styled.DiscountPrice>
                  {props.currency}
                  {(
                    Math.round(
                      parseFloat(
                        props.bookDiscountedPrice.toString().replace(/,/g, "")
                      ) * 100
                    ) / 100
                  ).toFixed(2)}
                </Styled.DiscountPrice>
                {/* {props.bagApi == "bag" ? (
                  props.discountCode.toUpperCase() == "ALERTSDISCOUNT" ? (
                    <span className="discount-code">{props.discountCode}</span>
                  ) : (
                    ""
                  )
                ) : (
                  <span className="discount-code">{props.discountCode}</span>
                )} */}
                <span className="discount-code">{props.discountCode}</span>
              </span>
            )}
          </div>
        </div>
        <Styled.ActionsStyle>
          <div className="price-subtotal">
            <Styled.ItemSubTotalStyle>
              {props.currency}
              {/* {props.bookSubTotal} */}
              {(
                Math.round(
                  parseFloat(props.bookSubTotal.toString().replace(/,/g, "")) *
                    100
                ) / 100
              ).toFixed(2)}
            </Styled.ItemSubTotalStyle>
          </div>
          {props.bagType == "unavailable" ? (
            <Styled.QuantityDisabledStyle>
              <span>{props.counter}</span>
            </Styled.QuantityDisabledStyle>
          ) : (
            <Styled.QuantityStyle>
              <Styled.HiddenLabelStyle htmlFor="quantity">
                Select quantity
              </Styled.HiddenLabelStyle>
              <select
                name="quantity"
                // defaultValue={props.counter}
                value={props.counter}
                onChange={props.changed}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
              </select>
            </Styled.QuantityStyle>
          )}

          {/* <Styled.CounterStyle></Styled.CounterStyle> */}
          <Styled.DeleteStyle
            type="button"
            onClick={props.openDeleteModal}
            aria-label="delete item"
            title="Remove this item from your bag"
          >
            remove item button
          </Styled.DeleteStyle>
        </Styled.ActionsStyle>
      </Styled.BagItemStyle>
    </div>
  );
};

export default BagItem;
